module.exports = __webpack_public_path__ + "static/banner_2-9e014e5c5e3d29e204f0a6afe017890b.png";